import api from '../NetworkService';
import { formatRequestDate } from '../utils/api';
import validateAndFormatDates from '../utils/metricsApiUtils';
import ADS_PLATFORMS from '../constants/AdsPlatformsConstants';

const BASE_ACCOUNT_URL = '/api/accounts';

export const getAccountEstimateMetric = ({
    selectedId,
    metrics,
    conversionType,
    typeOfSelectedObj = 'accounts',
    endDate,
    startDate,
}) => {
    const period = validateAndFormatDates(startDate, endDate);
    const query = {
        end_date: period.endDate,
        metrics,
        start_date: period.startDate,
        conversion_type: conversionType,
    };

    return api
        .getClient()
        .get(`/api/${typeOfSelectedObj}/${selectedId}/metrics/estimates/`, { params: query })
        .then(response => response.data);
};


const initialDate = new Date();
const finalDate = new Date();
initialDate.setDate(initialDate.getDate() - 90);
const dateRange = [
    `${formatRequestDate(initialDate)},${formatRequestDate(finalDate)}`,
];


export const loadAverage = ({
    dateRanges = dateRange,
    filterUntilHour,
    metrics,
    numSamples = undefined,
    segmentation = undefined,
    selectedId,
    conversionType,
    typeOfSelectedObj = 'accounts',
}) => api
    .getClient()
    .get(`/api/${typeOfSelectedObj}/${selectedId}/metrics/averages/`, {
        params: {
            date_ranges: dateRanges,
            filter_until_hour: filterUntilHour,
            metrics,
            num_samples: numSamples,
            segmentation,
            conversion_type: conversionType,
        },
    })
    .then(response => response.data);

export const loadTotal = ({
    selectedId,
    metrics,
    startDate,
    endDate,
    conversionType,
}) => api
    .getClient()
    .get(`${BASE_ACCOUNT_URL}/${selectedId}/metrics/totals/`, {
        params: {
            end_date: endDate,
            metrics,
            start_date: startDate,
            conversion_type: conversionType,
        },
    })
    .then(response => response.data);

const filterCampaignByPlatform = (campaigns, platform) => {
    if (!campaigns) return [];
    return campaigns.filter(campaign => campaign.platform === platform);
};

const filterCampaignsIds = (campaigns, platform) => {
    if (campaigns.length === 0) {
        return [];
    }

    const campaignsAndPlatform = filterCampaignByPlatform(campaigns, platform);
    const campaignsIds = campaignsAndPlatform.map(
        campaignAndPlatform => campaignAndPlatform.campaign_id,
    );

    return campaignsIds.join();
};

export const getReportConfig = ({
    customerType, customerId, startDate, endDate, segmentation, conversionType, campaigns,
}) => ({
    url: `/api/${customerType}/${customerId}/metrics/report/`,
    method: 'GET',
    params: {
        end_date: endDate,
        segmentation,
        start_date: startDate,
        conversion_type: conversionType,
        google_campaigns_ids: filterCampaignsIds(campaigns, ADS_PLATFORMS.GOOGLE_ADS),
        facebook_campaigns_ids: filterCampaignsIds(campaigns, ADS_PLATFORMS.FACEBOOK_ADS),
        teste: null,
    },
});

export const getAverage = ({
    dateRanges = dateRange,
    filterUntilHour,
    metrics,
    numSamples = undefined,
    segmentation = undefined,
    selectedId,
    conversionType,
    typeOfSelectedObj = 'accounts',
}) => ({
    url: `/api/${typeOfSelectedObj}/${selectedId}/metrics/averages/`,
    method: 'GET',
    params: {
        date_ranges: dateRanges,
        filter_until_hour: filterUntilHour,
        metrics,
        num_samples: numSamples,
        segmentation,
        conversion_type: conversionType,
    },
});
